import { escapeCsvCell } from "@/shared/utils/csv";

import type { OtcOrder } from "../types/cryptoSwaps.types";

export interface CryptoSwapCsvLabels {
  columns: string[];
  status: (order: OtcOrder) => string;
  network: (order: OtcOrder) => string;
}

/** Money stays the raw decimal string so the file re-imports losslessly. */
export function buildCryptoSwapCsv(orders: OtcOrder[], labels: CryptoSwapCsvLabels): string {
  const lines = orders.map((order) =>
    [
      escapeCsvCell(order.id),
      order.created_at,
      escapeCsvCell(labels.status(order)),
      order.send.amount,
      escapeCsvCell(order.send.currency),
      order.receive.amount,
      escapeCsvCell(order.receive.currency),
      order.price.value,
      order.fees.conversion.total,
      order.fees.delivery.total,
      escapeCsvCell(labels.network(order)),
      escapeCsvCell(order.destination.address),
      escapeCsvCell(order.destination.tx_hash),
      escapeCsvCell(order.concept),
      order.paid_at ?? "",
      order.failed_at ?? "",
    ].join(","),
  );

  return [labels.columns.map(escapeCsvCell).join(","), ...lines].join("\n");
}

/** Prefix + day, so a folder of exports stays sortable. */
export function cryptoSwapCsvFilename(prefix: string, now: Date = new Date()): string {
  return `${prefix}-${now.toISOString().slice(0, 10)}.csv`;
}
